import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import Button from '@mui/material/Button';
import connect from "react-redux/es/components/connect";
import translate from "../i18n/translate";
import { actionToggleFooter, actionToggleNavBar, actionToggleSideBar } from "../store/action/LayoutActionSupervisor";
import { updateSupervisorPassword } from "./common/FirebaseSupervisor";
import { getQueryVariable, isValidPassword, isLoginSupervisorAccessRightsLoaded, getLoginSupervisorAccessRights } from "../store/action/RemoteActionSupervisor";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";

const PasswordChange = (props) => {
    const [language, setLanguage] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [oldPassword, setOldPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isForceChange, setIsForceChange] = useState(false);
    const [isPasswordChangeSuccess, setIsPasswordChangeSuccess] = useState(false);

    const changePassword = async () => {
        if (!newPassword || !oldPassword || !passwordConfirm) {
            alert(getMultiLanguageMessage('msg_Incomplete_Input_Error', language));
            return;
        }
        if (newPassword === oldPassword) {
            alert(getMultiLanguageMessage('msg_SamePassword_Error', language));
            return;
        }
        if (newPassword !== passwordConfirm) {
            alert(getMultiLanguageMessage('msg_Password_Mismatch_Error', language));
            return;
        }
        let arCommonWords = [];
        if (props?.admin?.length > 0) {
            arCommonWords.push(props?.admin[0].FirstName);
            arCommonWords.push(props?.admin[0].LastName);
        }
        if (!isValidPassword(newPassword, arCommonWords)) {
            alert(getMultiLanguageMessage('msg_InvalidPasswordRule_Error', language));
            return;
        }
        if (window.confirm(getMultiLanguageMessage('msg_PasswordChange_Confirm', language))) {
            setIsButtonClicked(true);
            let isSuccess = await updateSupervisorPassword(newPassword);
            if (isSuccess) {
                if (isForceChange) {
                    await getLoginSupervisorAccessRights();
                }
                setIsPasswordChangeSuccess(true);
                alert(getMultiLanguageMessage('msg_Password_Change_Success', language));
                setOldPassword('');
                setNewPassword('');
                setPasswordConfirm('');
            } else {
                alert(getMultiLanguageMessage('msg_Password_Change_Failed', language));
            }
            setIsButtonClicked(false);
        }
    };

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        props.actionToggleNavBar(true);
        props.actionToggleSideBar(true);
        props.actionToggleFooter(true);
        let sReset = getQueryVariable(window.location.search, "Reset");
        if (sReset && parseInt(sReset) === 1) {
            setIsForceChange(true);
        } else {
            if (!isLoginSupervisorAccessRightsLoaded()) {
                setIsForceChange(true);
            }
        }
    }, []);

    return (
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-ChangePassword')}</h2>

            {(isForceChange && !isPasswordChangeSuccess) &&
                <div className="Message-Red">
                    {translate('Password-Expired-Message')}
                    <div className="gaps-1x" />
                </div>
            }

            {isPasswordChangeSuccess &&
                <div className="Message-Blue">
                    {translate('Password-Change-Success-Message1')}<br />
                    <a href='/dashboard'><b>{translate('Password-Change-Success-Message2')}</b></a>
                    <div className="gaps-1x" />
                </div>
            }

            {(!isForceChange || !isPasswordChangeSuccess) &&
                <div className="tab-content" id="security-opt-tab">
                    {/* .tab-pane */}
                    <div className="tab-pane active show" id="password-opt">
                        <form action="#">
                            {/* .row */}
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="input-item input-with-label">
                                        <TextField id="old-password" type={'password'} label={translate('Old-Password')} className='input-bordered' value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
                                    </div>
                                    {/* .input-item */}
                                </div>
                                {/* .col */}
                            </div>

                            {/* .row */}
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="input-item input-with-label">
                                        <TextField id="new-password" type={'password'} label={translate('New-Password')} className='input-bordered' value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                                    </div>
                                    {/* .input-item */}
                                </div>
                                {/* .col */}
                            </div>

                            {/* .row */}
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="input-item input-with-label">
                                        <TextField id="confirm-password" type={'password'} label={translate('Confirm-Password')} value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} className='input-bordered' />
                                    </div>
                                </div>
                            </div>

                            <div className="note note-plane note-info">
                                <em className="fas fa-info-circle" />
                                <p>
                                    {translate('password-eligibility-message')}
                                </p>
                            </div>
                            {isButtonClicked &&
                                <>
                                    <div className="gaps" />
                                    <img width={80} src={require('../assets/images/loading.gif')} srcSet={require('../assets/images/loading.gif')} alt="loading" />
                                </>
                            }
                            <div className="gaps-3x" />
                            {/* 10px gap */}
                            <div className="d-sm-flex justify-content-between align-items-center">
                                <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => changePassword()}>{translate('btnUpdate')}</Button>
                                <div className="gaps-2x d-sm-none" />
                            </div>
                        </form>
                        {/* form */}
                    </div>
                    {/* .tab-pane */}
                </div>
            }
        </div >
    );
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        admin: state.remote.admin
    };
};

export default connect(mapStateToProps, {
    actionToggleNavBar,
    actionToggleSideBar,
    actionToggleFooter
})(PasswordChange);
